import { all, takeLatest, call, put, select } from 'redux-saga/effects';
import { fetchUsers } from './Users.actions';
import { Action } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { AppContainerState, Roles, Unwrap, User } from '../../domains/app';
import UserService from '../../service/Persons.service';
import {
  setIsFetching,
  setPage,
  setListUsers,
  addUsers,
  setTotal,
} from './Users.slice';
import SpaceService from '../../service/Space.service';

function* fetchListUsersSaga(action: Action) {
  try {
    yield put(setIsFetching(true));
    if (fetchUsers.match(action)) {
      const refreshList = action.payload;
      if (refreshList) {
        yield put(setPage(0));
      }
      const selectedAccount: AppContainerState['selectedAccount'] = yield select(
        (state: RootState) => state.app.selectedAccount,
      );
      const page: number = yield select((state: RootState) => state.users.page);
      const pageSize: number = yield select(
        (state: RootState) => state.users.pageSize,
      );
      const search: string = yield select(
        (state: RootState) => state.users.search,
      );

      let items: User[];
      let totalCount: number;
      if (
        selectedAccount &&
        (selectedAccount.role & Roles.SpaceOwner ||
          selectedAccount.role & Roles.SpaceAdministrator)
      ) {
        const resMembers: Unwrap<ReturnType<
          typeof SpaceService.fetchListMembers
        >> = yield call(
          SpaceService.fetchListMembers,
          selectedAccount?.id as string,
          10000,
          0,
          search,
        );
        items = resMembers.items.map((m) => {
          m.person.enrolled = m.enrolled;
          return m.person;
        });
        totalCount = resMembers.total;
      } else {
        const resUsers: Unwrap<ReturnType<
          typeof UserService.fetchListUser
        >> = yield call(UserService.fetchListUser, pageSize, page, search);
        items = resUsers.items;
        totalCount = resUsers.total;
      }

      if (refreshList) {
        yield put(setListUsers([]));
      }
      yield put(addUsers(items));
      yield put(setTotal(totalCount));
      yield put(setPage(page + 1));
    }
  } catch (e) {
    console.error(e);
  } finally {
    yield put(setIsFetching(false));
  }
}

// eslint-disable-next-line
export default function* () {
  yield all([takeLatest(fetchUsers.toString(), fetchListUsersSaga)]);
}
